"use client";

import Script from "next/script";

declare global {
  interface Window {
    uetq?: any[];
    UET?: any;
  }
}

export default function AnalyticsScripts() {
  return (
    <>
      <Script
        src="https://bat.bing.com/bat.js"
        strategy="afterInteractive"
        onReady={() => {
          if (typeof window !== "undefined") {
            window.uetq = window.uetq || [];
            const uet = function (o: any) {
              o.ti = "187136125";
              o.enableAutoSpaTracking = true;
              window.uetq?.push("pageLoad");
            };
            window.UET && uet({});
          }
        }}
      />
    </>
  );
}